/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2020
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/
define(["require", "exports", "./mcp", "./async_call_channel"], function (require, exports, mcp_1, async_call_channel_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MCPChannel = void 0;
    class MCPChannel extends async_call_channel_1.AsyncCallChannel {
        constructor(channel, options) {
            super({}, {});
            this.options = options || {};
            let url = channel.url + "../modelcontextprotocol.2025-11-25/mcp";
            this.mcp = new mcp_1.ClientConnection();
            this.endpoint = new URL(url);
            this.asyncCallHandler = this.mcp.createCallHandler(this.endpoint);
        }
        call(path, request, responseObserver, formatOptions, callHeaders, options) {
            options = options || {};
            if (path != "search" && this.options.parentChannel) {
                return this.options.parentChannel.call(path, request, responseObserver, formatOptions, callHeaders, options);
            }
            else {
                return super.call(path, request, responseObserver, formatOptions, callHeaders, options);
            }
        }
        destroy(options) {
            super.destroy(options);
        }
    }
    exports.MCPChannel = MCPChannel;
});
